import { render, staticRenderFns } from "./LoadingPage.vue?vue&type=template&id=a1404780"
var script = {}
import style0 from "./LoadingPage.vue?vue&type=style&index=0&id=a1404780&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports